<div class="login-page d-flex flex-column min-vh-100">
	<div class="login-main d-flex">

		<!-- Left: cover photo -->
		<div class="login-photo portal-brand-fill" [style.background-image]="coverUrl ? 'url(' + coverUrl + ')' : null">
			<div class="portal-logo logo-box"><portal-brand-logo></portal-brand-logo></div>
		</div>

		<!-- Right: form -->
		<div class="login-form-panel d-flex flex-column align-items-center justify-content-center">
			<div class="login-form-inner d-flex flex-column">
				<div class="portal-logo login-company-logo"><portal-brand-logo></portal-brand-logo></div>

				<ng-container *ngIf="!sent">
					<h1 class="login-heading">Forgot your password?</h1>
					<p class="fp-subtext">Enter your email address and we'll send you a link to reset your password.</p>

					<form (ngSubmit)="submit()">
						<div class="form-group">
							<label for="fp-email">E-mail</label>
							<input id="fp-email" class="form-control" type="email" name="email" placeholder="example@example.com"
								[(ngModel)]="email" autocomplete="username" />
						</div>

						<div class="login-error portal-error" *ngIf="error">{{ error }}</div>

						<button type="submit" class="btn btn-primary btn-block" [disabled]="loading">
						{{ loading ? 'Sending…' : 'Send Reset Link' }}
					</button>
					</form>
				</ng-container>

				<div class="fp-success" *ngIf="sent">
					<div class="fp-success-icon"><i class="wq wq-check"></i></div>
					<p class="fp-success-title">Check your email</p>
					<p class="fp-success-msg">If an account exists for that address, we've sent a link to reset your password. Check your inbox and follow the instructions.</p>
				</div>

				<button class="fp-back-btn" routerLink="/login">
					<i class="wq wq-chevron-left"></i>
					Back to Sign In
				</button>
			</div>
		</div>
	</div>

	<!-- Footer bar -->
	<div class="login-footer d-flex align-items-center justify-content-between flex-wrap">
		<div class="powered-by d-flex align-items-center gap-2">
			<span>Powered by</span>
			<img class="powered-logo powered-logo-light" src="assets/img/logo/wequote-text-dark.png" alt="WeQuote" />
			<img class="powered-logo powered-logo-dark" src="assets/img/logo/wequote.svg" alt="WeQuote" />
		</div>
		<div class="footer-links d-flex gap-4">
			<button type="button" class="portal-link-button" (click)="termsModal.open()">Terms of Use</button>
			<button type="button" class="portal-link-button" (click)="privacyModal.open()">Privacy Notice</button>
		</div>
	</div>
</div>

<!-- Read-only policy popups, opened from the footer. -->
<portal-terms-modal #termsModal></portal-terms-modal>
<portal-privacy-modal #privacyModal></portal-privacy-modal>
